import { Dialog, DialogProps, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export const KDialog = ({ children, ...props }: DialogProps) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      {...props}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          paddingX: 3,
          minHeight: 400,
        },
      }}
    >
      {children}
    </Dialog>
  )
}
